import React, { useState } from "react"
import {
  InstagramLogoIcon,
  FacebookLogoIcon,
  TiktokLogoIcon,
  PinterestLogoIcon,
  EnvelopeIcon,
  ArrowUpRightIcon,
} from "@phosphor-icons/react"

// assets
import bbLogo from "@images/Home/blackbough-logo.svg"

const NewsLetter = () => {

    const [email, setEmail] = useState("");
    const [errorMessage ,setErrorMessage] = useState("");
    const [successMessage ,setSuccessMessage] = useState("");

    const handleNewsletter = async () => {
        setErrorMessage("")
        setSuccessMessage("")
        
        try {
            const res = await fetch("/submit-newsletter", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: email,
                }),
            });
            const data = await res.json();
            
            if(data?.status === "Subscribed") {
                setSuccessMessage("You have successfully subscribed to our newsletter.")
		        setEmail("")
            } else {
                setErrorMessage("There is an error subscribing, please try a different email address.")
                setEmail("")
            }
            
        } catch (err) {
            setErrorMessage("Error subscribing, please try again later.")
            setEmail("")
        }
    }

    return (
        <React.Fragment>
        <section className="news-letter">
            <h5 className="text-[0.875rem]">NEWSLETTER</h5>
            <p>
                Sign up for our newsletter and be first on sales and new releases!
            </p>
            {
                errorMessage !== "" ? <div className="bg-danger text-white p-2 mb-2">{errorMessage}</div> : null
            }

            {
                successMessage !== "" ? <div className="bg-success text-white p-2 mb-2">{successMessage}</div> : null
            }

            <section className="flex flex-nowrap justify-between flex-1 gap-x-3 mb-8">
            <input
                className="p-4 w-full text-base font-normal border border-[#D1D1D1]"
                type="email"
                name="email"
                placeholder="Your email address"
                aria-label="Your email address"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />

            <button
                className="btn-primary"
                aria-label="newsletter-submit"
                onClick={handleNewsletter}
            >
                <ArrowUpRightIcon size={24} />
            </button>
            </section>

            <p>Or follow us through our social media pages</p>
        
            <div className="mb-4">
            <img
                className="h-auto w-[150px] lg:w-[276px] mx-auto md:ml-0 justify-self-center md:justify-self-start"
                src={bbLogo}
                alt={"Blackbough Swim"}
            />
            </div>

            <section className="text-[#3D3D3D] flex justify-center md:justify-start gap-x-4">
            <a 
                href={'https://www.instagram.com/blackboughswim/?hl=en'}
                target="_blank"
                aria-label="follow-instagram"
            >
                <InstagramLogoIcon
                size={24}
                weight="light"
                />
            </a>
            <a 
                href={'https://www.facebook.com/blackboughswim/'}
                target="_blank"
                aria-label="follow-facebook"
            >
                <FacebookLogoIcon
                size={24}
                weight="light"
                />
            </a>
            <a 
                href={'https://www.tiktok.com/@blackboughswimofficial'}
                target="_blank"
                aria-label="follow-tiktok"
            >
                <TiktokLogoIcon
                size={24}
                weight="light"
                />
            </a>
            {/* <a 
                href={'#'}
                target="_blank"
            >
                <YoutubeLogo
                size={24}
                weight="light"
                onClick={() => handleSocialMediaLinks("youtube")}
                />
            </a> */}
            <a 
                href={'https://pinterest.com/blackbough_swim/'}
                target="_blank"
                aria-label="follow-pinterest"
            >
                <PinterestLogoIcon
                size={24}
                weight="light"
                />
            </a>
            <a 
                href={'mailto:aloha@blackboughswim.com'}
                target="_blank"
                aria-label="email"
            >
                <EnvelopeIcon
                size={24}
                weight="light"
                />
            </a>
            {/* <a 
                href={'#'}
                target="_blank"
            >
                <TwitterLogo
                size={24}
                weight="light"
                onClick={() => handleSocialMediaLinks("twitter")}
                />
            </a> */}
            </section>
        </section>
        </React.Fragment>
    );
}

export default NewsLetter